import {
  fundOverviewData,
  nfoOverviewData,
} from '../../singleFund/singleFundConst';
import { SubHeading } from '../../common/subHeading';

export const FundOverView = ({ fundData }) => {
  const { isNfo } = fundData;
  const fundOverViewArr = isNfo
    ? nfoOverviewData(fundData)
    : fundOverviewData(fundData);

  return (
    <div className={`${!isNfo && 'lil-mt-5'}`}>
      {!isNfo && <SubHeading title="Fund overview" />}
      <div className={`lil-rounded-xl lil-bg-white ${!isNfo && 'lil-mt-4'}`}>
        <ul className="lil-w-full">
          {fundOverViewArr.map((item, index) => (
            <li
              key={index}
              className={`lil-flex lil-justify-between lil-items-center lil-py-3 lil-relative`}
            >
              <span className="lil-font-light lil-text-grey-600 lil-w-2/5">
                {item.heading}
              </span>
              <span className="lil-font-semibold lil-text-grey-900 lil-w-1/2 lil-text-right">
                {item.data}
              </span>
              {index !== fundOverViewArr.length - 1 && (
                <div className="lil-absolute lil-h-px lil-bg-grey-300 lil-bottom-0 lil-left-0 lil-right-0"></div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/fundOverview/index.tsx